import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DebugModeService {
  readonly devModeEnabled$ = new BehaviorSubject<boolean>(false);

  isDevModeEnabled(): boolean {
    return this.devModeEnabled$.getValue();
  }
}
